// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"cffca801","128":"f07916ef","250":"9ea60edb","413":"98b17b06","453":"9f02c00c","692":"2a5f12f3","726":"efee1af4","863":"e0d1b626","884":"0fe832f2","886":"0af01414"}[chunkId] + ".chunk.js";
};